import type { EdgeMouseEvent } from 'components/Graph/GraphApp/events/GraphAppEvents';
import type { GraphRendererPlugin } from 'components/Graph/GraphApp/plugins/GraphRendererPlugin';
import { openEdgeContextMenu } from 'components/Graph/commands/edges/openEdgeContextMenu';
import { getGraphMouseEventPosition } from '../helpers/getGraphMouseEventPosition';

export const edgeContextMenu: GraphRendererPlugin = (pluginInterface) => {
  pluginInterface.events.addListener('edgeAdded', (edgeAddedEvent) => {
    edgeAddedEvent.edge.on('rightclick', (rightDownEvent: EdgeMouseEvent) => {
      // delay to prevent immediately closing due to considering current event to be "click outside"
      setTimeout(() => {
        pluginInterface.graphDispatch(openEdgeContextMenu, {
          edgeId: edgeAddedEvent.id,
          position: getGraphMouseEventPosition(rightDownEvent),
        });
      }, 0);
    });
  });
};
